import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AppShell } from './AppShell';
import { SoloGameChrome } from './SoloGameChrome';
function isFullBleedPath(pathname) {
    return (pathname.startsWith('/onboarding') ||
        pathname.startsWith('/auth/') ||
        pathname.startsWith('/session/') ||
        pathname === '/splash');
}
/** /play/<slug> (un seul segment apres /play, pas /play tout court). */
function isSoloGamePath(pathname) {
    return /^\/play\/[^/]+\/?$/.test(pathname);
}
export function RootLayout({ children }) {
    const location = useLocation();
    const { isAuthenticated, isLoading } = useAuth();
    const fullBleed = isFullBleedPath(location.pathname);
    const soloGame = isSoloGamePath(location.pathname);
    if (fullBleed || (!isAuthenticated && !isLoading)) {
        return (_jsx("div", { className: "min-h-dvh w-full bg-cyan-bg text-cyan-text font-body antialiased", children: _jsx("main", { className: "mx-auto flex min-h-dvh max-w-[430px] flex-col px-5 pt-4 pb-4", children: _jsx("div", { className: "flex-1", children: children }) }) }));
    }
    if (soloGame) {
        return (_jsx("div", { className: "min-h-dvh w-full bg-cyan-bg text-cyan-text font-body antialiased", children: _jsx(SoloGameChrome, { children: children }) }));
    }
    return (_jsx("div", { className: "min-h-dvh w-full bg-cyan-bg text-cyan-text font-body antialiased", children: _jsx(AppShell, { children: children }) }));
}
//# sourceMappingURL=RootLayout.js.map